module.exports = __webpack_public_path__ + "static/media/processing-video.3a9e5e22.jpg";